import React from 'react';
import { storiesOf } from '@storybook/react';
import Notification, { notify } from './Notification';

storiesOf('Common/Notification', module)
  .add('View', () => (
    <div>
      <Notification/>
      <button className="btn btn-info" onClick={() => notify.info('Info')}>
        Info
      </button>
      <button className="btn btn-success" onClick={() => notify.success('Success message')}>
        Success
      </button>
      <button className="btn btn-warning" onClick={() => notify.warn('Warning')}>
        Warning
      </button>
      <button className="btn btn-danger" onClick={() => notify.error('Failed action')}>
        Error
      </button>
    </div>
  ));




// WEBPACK FOOTER //
// ./src/components/common/Notification/Notification.stories.jsx